module.exports = __webpack_public_path__ + "img/td_D1.13.b31ac8a2.png";